import { createToolParameters } from '@goat-sdk/core';
import { z } from 'zod';

const voterType = z
  .enum(['veMODE', 'veBPT', 'all'])
  .optional()
  .default('all')
  .describe('Type of voter contract to query (veMODE or veBPT)');

const stakeType = z.enum(['veMODE', 'veBPT']).describe('Type of stake to execute (veMODE or veBPT)');

// Staking

export class ExecuteGovernanceStakeParameters extends createToolParameters(
  z.object({
    amount: z.number().min(100).describe('The amount of tokens to stake in base units (18 decimals).'),
    stakeType,
  })
) {}
export class ExecuteGovernanceUnStakeParameters extends createToolParameters(
  z.object({
    amount: z.number().min(100).describe('The amount of tokens to un-stake in base units (18 decimals).'),
    stakeType,
  })
) {}
export class GetModeGovernanceInfoParameters extends createToolParameters(
  z.object({
    voterType,
  })
) {}

// Voting

// For getting specific gauge info
export class GetGaugeInfoParameters extends createToolParameters(
  z.object({
    voterType: z.enum(['veMODE', 'veBPT']).describe('Type of voter contract to query (veMODE or veBPT)'),
    gaugeAddress: z.string().describe('Address of the gauge to query'),
  })
) {}

export class VoteOnGaugesParameters extends createToolParameters(
  z.object({
    votes: z
      .array(
        z.object({
          gauge: z.string().describe('Address of the gauge to vote on'),
          weight: z.string().describe('Weight percentage for this gauge (0-100)'),
        })
      )
      .min(1)
      .describe('Array of gauge addresses and their corresponding vote weights'),
  })
) {}
